import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetModule,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  selector: 'loading',
  templateUrl: 'loading.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatBottomSheetModule, MatProgressBarModule]
})
export class Loading {

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    public bottomSheetRef: MatBottomSheetRef<Loading>
  ) { }

}